<template>
  <h4>{{textToRender}}</h4>
</template>

<script>
export default {
  data () {
    return {
      textData: ''
    }
  },
  props: {
    text: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    textToRender () {
      return this.text || this.textData
    }
  }
}
</script>
